import styled from "styled-components";
import { IoMdMan } from "@react-icons/all-files/io/IoMdMan";

export const ContentWrap = styled.div`
  display: flex;
  padding: 10px;
  justify-content: space-around;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 17px 35px 23px;
`;

export const StylishMan = styled(IoMdMan)`
  width: 26px;
  height: 63px;
  margin-right: 5px;
`;

export const PeepsRowContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const PeepsContainer = styled.div`
  width: 47%;
  max-width: 553px;
  &.left-side {
    ${PeepsRowContainer} {
      flex-direction: row-reverse;
    }
  }
`;

export const PeepsContainerSingle = styled.div`
  width: 94%;
  max-width: 1106px;
  &.left-side {
    ${PeepsRowContainer} {
      flex-direction: row-reverse;
    }
  }
`;

export const BreakerBreaker = styled.div`
  width: 1px;
  height: 204px;
  background-color: lightgray;
`;

export const PeepsText = styled.p`
  font-size: 15px;
`;
